module.exports = __webpack_public_path__ + "static/img/zwsl.5211db0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zwsl.png
// module id = O4oB
// module chunks = 1